export default function appendSpotlightTracking($spotLightCarousel, trackingObj = {}) {
    if ($spotLightCarousel.length) {
        const $spotlightActiveSlide = $spotLightCarousel.find('.swiper-slide-active');
        const $spotlightCountdown = $spotlightActiveSlide.find('.spotlight-countdown');
        const $spotlightLink = $spotlightActiveSlide.find('.spotlight-link');
        const aaLinkData = $spotlightLink.attr('aa-link').split('|');

        if (aaLinkData) {
            let spotlightTrackingObj = {
                carouselPresentationStyle: 'spotlight',
                clientTimestamp: Date.now(),
                videoId: aaLinkData[25] ?? '',
                videoPreviewId: aaLinkData[18] ?? '',
                streamStartTimestamp:
                    $spotlightCountdown.data('stream-start-timestamp') ?? aaLinkData[26] ?? '',
                streamEndTimestamp:
                    $spotlightCountdown.data('stream-end-timestamp') ?? aaLinkData[27] ?? '',
                contentStatus: aaLinkData[28] ?? '',
                rowHeaderTitle: aaLinkData[4] ?? '',
                spliceEnabled: '0',
                ctaText: $spotlightActiveSlide
                    .find('.spotlight-button:visible .button__text')
                    .first()
                    .text(),
                carouselId: $spotLightCarousel.data('carouselid') ?? trackingObj.carouselId ?? '',
                isHighlightEnabled: 'false',
                carouselContentType: aaLinkData[30] ?? '',
                carouselLink: $spotlightLink.attr('href') ?? '',
                posRowNum: $spotLightCarousel?.data('position')?.toString() ?? '0',
                posColNum: $spotlightActiveSlide?.data('swiper-slide-index')?.toString() ?? '0',
                showSeriesId: aaLinkData[6] ?? '',
                showSeriesTitle: aaLinkData[14] ?? '',
                showEpisodeTitle: aaLinkData[5] ?? '',
                showEpisodeId: aaLinkData[20] ?? '',
                showSeasonNumber: aaLinkData[7] ?? '',
                hubId: aaLinkData[24] ?? '',
                showGenre: aaLinkData[30] !== 'movie' ? aaLinkData[15] : '',
                contentBrand: aaLinkData[10] ? aaLinkData[10] : 'na',
                movieId: aaLinkData[30] === 'movie' ? aaLinkData[16] : '',
                movieTitle: aaLinkData[30] === 'movie' ? aaLinkData[0] : '',
                movieGenre: aaLinkData[30] === 'movie' ? aaLinkData[15] : '',
                contentLocked: aaLinkData[23] ?? '',
                carouselModel: $spotLightCarousel.data('model') ?? trackingObj.carouselModel,
                postersContentList: getPaginationContentIds($spotLightCarousel) ?? '',
            };

            trackingObj = { ...spotlightTrackingObj, ...trackingObj };
            return trackingObj;
        }
    }
}

function getPaginationContentIds($spotLightCarousel) {
    return $spotLightCarousel
        .closest('.spotlight-carousel')
        .find('.swiper-pagination')
        .data('contentids');
}
